import React, { useEffect, useLayoutEffect, useState } from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import Logo from "../../../assets/logo_dam.png";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { Collapse } from "@mui/material";
import SubMenuData from "../../utils/DataMenu";
import { useTranslation } from "react-i18next";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useHistory,useLocation } from "react-router-dom";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import "./SideBar.css";
import { GlobalHooks } from "../../../utils/Hooks";
import { useAppSelector } from "../../../redux/hooks";
import HasPermission from "../HasPermission/HasPermission";
import Cookies from "js-cookie";
import { Helpers } from "../../../utils/helpers";
const Sidebar = ({ open, handleOnCollapse }) => {
  const permissions = useAppSelector(
    (state) => state.ConnexionReducer.constraintData.permissions
  );
  const isAdmin = useAppSelector(
    (state) => state.ConnexionReducer.constraintData.isAdmin
  );
  const { cookies } = GlobalHooks();
  const [sectionOpen, setSectionOpen] = useState([]);
  const [moduleChosen, setModuleChosen] = useState("/dashboard");
  const [redic, setRedic] = useState([]);
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation()
  const url = location.pathname;
  const {acces_send} =Helpers()

  const findOutIfOpened = (e) => {
    const index = sectionOpen.indexOf(e);
    const listItems = url.split("/");
    if(e === url){
      return window.location.reload()
    }
    if(sectionOpen.length === 0){
      setSectionOpen([e])
    }
    if (index >= 0) {
      const newItems = sectionOpen.slice(0);
      newItems.splice(index, 1);
      setSectionOpen(newItems);
    } else {
      setSectionOpen((prev) => [...new Set([...prev, e])]);
    }
  };
  useEffect(()=>{
    const listItems = location.pathname.split("/");
    const listDropdownItems = [`/${listItems[1]}`];
    listItems[2] && listDropdownItems.push(`/${listItems[1]}/${listItems[2]}`);
    listItems[3] && listDropdownItems.push(`/${listItems[1]}/${listItems[2]}/${listItems[3]}`);
    setModuleChosen(listDropdownItems[listDropdownItems.length - 1])
    setSectionOpen(listDropdownItems)
  },[location.pathname])

  const dissableModulesByItSelf = (y) => {
    if (
      y === "/media/image" ||
      y === "/media/chutier" ||
      y === "/configuration/news" ||
      y === "/media/scorm" ||
      y === "/configuration/referrers" ||
      y === "/configuration/configuration_mooc" ||
      y === "/configuration/player_parameters" ||
      y === "/stat/consumptions" ||
      y === "/stat/stockage" ||
      y === "/stat/mooc"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const disabledModulesByParent = (x) => {
    if (
      x === "/abonnement" ||
      x === "/interactivity" ||
      x === "/specifics" ||
      x === "/display" ||
      x === "/display_new" ||
      x === "/skin"
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      {cookies.LayoutTheme === "L3" || cookies.LayoutTheme === "L2" ? (
        <></>
      ) : (
        <Box
          className={`sidebarGlobal ${open ? "mobileee" : ""}`}
          sx={{
            p: open ? "10px" : 0,
            marginTop: cookies.LayoutTheme === "L1" ? "64px" : "",
            width: open ? 250 : 90,
            position: "fixed",
            zIndex: 5,
            height: "100vh",
            backgroundColor:
              cookies.ColorTheme === "default"
                ? "#F8FBFF"
                : cookies.ColorTheme === "c2"
                ? "#cee3e7"
                : cookies.ColorTheme === "c3"
                ? "#426c7a"
                : cookies.ColorTheme === "c4"
                ? "#8499e4"
                : cookies.ColorTheme === "c5"
                ? "#11776c"
                : "#aaaaaa",
          }}
        >
          {cookies.LayoutTheme === "default" && (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 2,
                  height: 64,
                  paddingRight: "3px",
                }}
              >
                {open && <img src={Logo} alt="Logo" height={40} />}
                {open ? (
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{
                      color: "black",
                      width: "45px",
                      height: "70px",
                      marginLeft: "auto",
                    }}
                    onClick={handleOnCollapse}
                  >
                    <MenuOpenIcon />
                  </IconButton>
                ) : (
                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{
                      color: "black",
                      width: "80px",
                      height: "70px",
                    }}
                    onClick={handleOnCollapse}
                  >
                    <MenuIcon fontSize="large" />
                  </IconButton>
                )}
              </Box>
            </>
          )}
          <List className="sidebar">
            {permissions &&
              SubMenuData &&
              SubMenuData.map((e) => (
                <div key={e.id}>
                  <HasPermission
                    redi={redic}
                    permission={e.Permissions}
                    isAdmin={isAdmin}
                    per={permissions}
                    childs={e}
                    allowed={
                      !(
                        permissions?.userData?.modules[e.Permissions] !==
                          true && !isAdmin
                      )
                    }
                  >
                    <ListItem
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        marginBottom: "6px",
                        backgroundColor:
                          url.includes("/stat/dashboard") && e.indicatorSolutionOnly === "/dashboard"
                          ? ""
                          : url.includes(e.indicatorSolutionOnly)
                            ? cookies.ColorTheme === "default"
                              ? "#1976D2"
                              : cookies.ColorTheme === "c2"
                              ? "#002d3d"
                              : cookies.ColorTheme === "c3"
                              ? "#b4c7e5"
                              : cookies.ColorTheme === "c4"
                              ? "#ffcd38"
                              : cookies.ColorTheme === "c5"
                              ? "#8ee5dc"
                              : "#F32B84"
                            : "",
                        borderRadius: "12px",
                        marginLeft: "1px",
                        gap: "10px",
                      }}
                      onClick={() => {
                        if(e.indicatorSolutionOnly =="/dashboard") acces_send("dashboard_page_action")
                        findOutIfOpened(e.indicatorSolutionOnly);
                        if (!(e.MenuItem.length > 0)) {
                          setModuleChosen(e.indicatorSolutionOnly);
                          history.push(e.indicatorSolutionOnly);
                        }
                      }}
                    >
                      {!url.includes(e.indicatorSolutionOnly) || (url.includes("/stat/dashboard") && e.indicatorSolutionOnly === "/dashboard")
                      ? (
                        <i
                          style={{color:"black"}}
                          className={`${
                            url.includes(e.indicatorSolutionOnly) && !(url.includes("/stat/dashboard") && e.indicatorSolutionOnly === "/dashboard")
                              ? e.iconClass + "white"
                              : e.iconClass
                          } ${
                            e.indicatorSolutionOnly === moduleChosen && !open
                              ? "blackerr"
                              : ""
                          }`}
                        ></i>
                      ) : (
                        <><i className={`${e.iconClass + "white"}`}></i></>
                      )}
                      {open && (                       
                        <ListItemText
                          sx={{
                            color:
                                url.includes("/stat/dashboard") && e.indicatorSolutionOnly === "/dashboard"
                                ? "#6C737F"
                                : url.includes(e.indicatorSolutionOnly) 
                                ? "white"
                                : e.indicatorSolutionOnly === moduleChosen 
                                ? "#1890FF"
                                : Cookies.get("ColorTheme") === "default"
                                ? "#6C737F"
                                : Cookies.get("ColorTheme") === "c2"
                                ? "#002d3d"
                                : Cookies.get("ColorTheme") === "c3"
                                ? "#b4c7e5"
                                : Cookies.get("ColorTheme") === "c4"
                                ? "#ffcd38"
                                : Cookies.get("ColorTheme") === "c5"
                                ? "#8ee5dc"
                                : "#F32B84",
                          }}
                          primary={t(e.title)}
                        />
                      )}
                      {open &&
                        e.MenuItem.length >= 1 &&
                        (!(
                          sectionOpen.indexOf(e.indicatorSolutionOnly) >= 0
                        ) ? (
                          e.key !== "/abonnement" ? (
                            <KeyboardArrowRightIcon
                              sx={{
                                color:
                                url.includes(e.indicatorSolutionOnly)
                                    ? "white"
                                    : "black",
                              }}
                            />
                          ) : (
                            <DoNotDisturbIcon sx={{ color: "black" }} />
                          )
                        ) : (
                          <KeyboardArrowDownIcon
                            sx={{
                              color:
                                url.includes(e.indicatorSolutionOnly)
                                  ? "white"
                                  : "black",
                            }}
                          />
                        ))}
                    </ListItem>
                    {e.MenuItem.length >= 1 &&
                      sectionOpen.indexOf(e.indicatorSolutionOnly) >= 0 &&
                      e.MenuItem.map((u) => (
                        <HasPermission
                          redi={redic}
                          permission={u.Permissions}
                          isAdmin={isAdmin}
                          per={permissions}
                          childs={u}
                          allowed={
                            !(
                              permissions?.userData?.modules[u.Permissions] !==
                                true && !isAdmin
                            )
                          }
                        >
                          <Collapse
                            key={u.id}
                            in={
                              sectionOpen.indexOf(e.indicatorSolutionOnly) >= 0
                            }
                            timeout="auto"
                            unmountOnExit
                          >
                            <List
                              sx={{ paddingLeft: "20px" }}
                              component="div"
                              disablePadding
                              onClick={() =>
                                findOutIfOpened(u.indicatorSolutionOnly)
                              }
                            >
                              <ListItem
                                onClick={() => {
                                  acces_send(`${u?.Permissions}_action`)
                                  if (
                                    !(u.MenuItem.length > 0) &&
                                    !disabledModulesByParent(
                                      e.indicatorSolutionOnly
                                    ) &&
                                    !dissableModulesByItSelf(
                                      u.indicatorSolutionOnly
                                    )
                                  ) {
                                    setModuleChosen(u.indicatorSolutionOnly);
                                    history.push(u.indicatorSolutionOnly);
                                  }
                                }}
                                sx={{
                                  color: "black",
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  gap: "10px",
                                }}
                                className="item-sidebar"
                              >
                                <i
                                  className={`${u.iconClass} icon-sidebar ${
                                    u.indicatorSolutionOnly === moduleChosen &&
                                    !open
                                      ? "selected_sidebar_item"
                                      : u.indicatorSolutionOnly === "/boitier/rmbox" && url.includes("rmboxgroup")
                                      ? ""
                                      : url.includes(u.indicatorSolutionOnly) 
                                      ? "selected_sidebar_item"
                                      : ""
                                  }`}
                                ></i>
                                {open && (
                                  <ListItemText
                                    sx={{
                                      fontFamily: "Roboto",
                                      color:
                                      u.indicatorSolutionOnly === "/boitier/rmbox" && url.includes("rmboxgroup")
                                      ? "#6C737F"
                                      : url.includes(u.indicatorSolutionOnly)
                                          ? "#1890FF"
                                          : Cookies.get("ColorTheme") ===
                                            "default"
                                          ? "#6C737F"
                                          : Cookies.get("ColorTheme") === "c2"
                                          ? "#002d3d"
                                          : Cookies.get("ColorTheme") === "c3"
                                          ? "#b4c7e5"
                                          : Cookies.get("ColorTheme") === "c4"
                                          ? "#ffcd38"
                                          : Cookies.get("ColorTheme") === "c5"
                                          ? "#8ee5dc"
                                          : "#F32B84",
                                    }}
                                    className="title-sidebar"
                                    primary={t(u.title)}
                                  />
                                )}
                                {open &&
                                  u.MenuItem.length >= 1 &&
                                  (!(
                                    sectionOpen.indexOf(
                                      u.indicatorSolutionOnly
                                    ) >= 0
                                  ) ? (
                                    <KeyboardArrowRightIcon
                                      sx={{ color: "black" }}
                                    />
                                  ) : (
                                    <KeyboardArrowDownIcon
                                      sx={{ color: "black" }}
                                    />
                                  ))}
                                {open &&
                                  (disabledModulesByParent(
                                    e.indicatorSolutionOnly
                                  ) ||
                                  dissableModulesByItSelf(
                                    u.indicatorSolutionOnly
                                  ) ? (
                                    <DoNotDisturbIcon sx={{ color: "black" }} />
                                  ) : (
                                    <></>
                                  ))}
                              </ListItem>
                            </List>
                            {u.MenuItem.length > 0 &&
                              sectionOpen.indexOf(u.indicatorSolutionOnly) >=
                                0 &&
                              u.MenuItem.map((k) => (
                                <HasPermission
                                  redi={redic}
                                  permission={k.Permissions}
                                  allowed={
                                    !(
                                      permissions?.userData?.modules[
                                        k.Permissions
                                      ] !== true && !isAdmin
                                    )
                                  }
                                >
                                  <Collapse
                                    key={k.id}
                                    in={
                                      sectionOpen.indexOf(
                                        u.indicatorSolutionOnly
                                      ) >= 0
                                    }
                                    timeout="auto"
                                    unmountOnExit
                                  >
                                    <List
                                      sx={{ paddingLeft: "40px" }}
                                      component="div"
                                      disablePadding
                                      >
                                      <ListItem
                                       className={k.indicatorSolutionOnly === moduleChosen ? "selected_sidebar_item" :"item-sidebar"}
                                        onClick={() => {
                                          if (!(k.MenuItem.length > 0)) {
                                            setModuleChosen(
                                              k.indicatorSolutionOnly
                                            );
                                            history.push(
                                              k.indicatorSolutionOnly
                                            );
                                          }
                                        }}
                                        sx={{
                                          color: "black",
                                          display: "flex",
                                          alignItems: "center",
                                          cursor: "pointer",
                                          gap: "10px",
                                        }}
                                      >
                                        <i className={`${k.iconClass} ${k.indicatorSolutionOnly !== moduleChosen && "icon-sidebar"}`}></i>
                                        {open && (
                                          <ListItemText
                                          className="title-sidebar"
                                            sx={{
                                              color:
                                                k.indicatorSolutionOnly ===
                                                moduleChosen
                                                  ? "black"
                                                  : Cookies.get(
                                                      "ColorTheme"
                                                    ) === "default"
                                                  ? "#6C737F"
                                                  : Cookies.get(
                                                      "ColorTheme"
                                                    ) === "c2"
                                                  ? "#002d3d"
                                                  : Cookies.get(
                                                      "ColorTheme"
                                                    ) === "c3"
                                                  ? "#b4c7e5"
                                                  : Cookies.get(
                                                      "ColorTheme"
                                                    ) === "c4"
                                                  ? "#ffcd38"
                                                  : Cookies.get(
                                                      "ColorTheme"
                                                    ) === "c5"
                                                  ? "#8ee5dc"
                                                  : "#F32B84"
                                            }}
                                            primary={t(k.title)}
                                          />
                                        )}
                                      </ListItem>
                                    </List>
                                  </Collapse>
                                </HasPermission>
                              ))}
                          </Collapse>
                        </HasPermission>
                      ))}
                  </HasPermission>
                </div>
              ))}
          </List>
        </Box>
      )}
    </>
  );
};

export default Sidebar;
